<template>
  <div>
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-7 container-app">
            <div class="row title-row">
              <div class="title">Datos del Vertical</div>
            </div>
            <div>
              <q-toggle
                data-cy="toggle-visible-vertical"
                color="primary"
                v-model="visible"
                label="Visible en Catálogo"
                left-label
              />
            </div>
            <div class="input-row">
              <q-input
                data-cy="name-vertical"
                v-model="v$.name.$model"
                outlined
                debounce="1000"
                :error="v$.name.$error"
                label="*Nombre vertical"
                counter
                maxlength="255"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
                <template v-slot:hint>Restante</template>
              </q-input>
            </div>
            <div class="input-row">
              <q-input
                data-cy="order-app"
                v-model="v$.orden.$model"
                outlined
                debounce="1000"
                :error="v$.orden.$error"
                label="*Orden"
                type="number"
                min="0"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="col-5 container-images">
            <div>
              <UploadImage
                data-cy="logotipo-app"
                imgDefault="img/logo-dinapsis-aplicaciones.svg"
                label="CAMBIAR LOGO"
                v-model="imgImagen"
                :showPreview="{
                  show: true,
                  sizes: {
                    width: '111px',
                    height: '108px',
                  },
                  ratio: 16 / 9,
                }"
                @input="updateLogotipo = true"
              />
            </div>
            <div class="input-row upload-row">
              <div
                style="width: 100%;
                  overflow: hidden;
                  word-wrap: break-word;
                  word-break: word;
                  text-overflow: ellipsis;
                "
              >
                {{ video ? video.name : "" }}
              </div>
              <q-file
                accept="video/mp4"
                standout
                dense
                max-files="1"
                :multiple="false"
                bg-color="primary"
                input-class="inputStyle"
                v-model="video.file"
                @input="refreshVideoInfo()"
                display-value="SUBIR VIDEO"
                :loading="isUploading"
              >
                <template v-slot:prepend>
                  <q-icon
                    class="upload-icon"
                    :name="'img:' + require('@/assets/img/upload-outline.svg')"
                  />
                </template>
              </q-file>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-10 info-box">
            <div style="margin-right: 6px">
              <q-img
                :src="require('@/assets/img/info-24px.svg')"
                width="24px"
                height="24px"
              />
            </div>
            <div class="txt-info">
              SI EL NOMBRE O DESCRIPCIÓN EXCEDE LOS LÍMITES RECOMENDADOS, LA
              INFORMACIÓN PUEDE NO VISUALIZARSE CORRECTAMENTE EN TODOS LOS
              DISPOSITIVOS.
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Validation from '@/components/shared/mixins/Validation.js';
import UploadImage from '@/shared/uploadImage/components/UploadImage.vue';
import { QToggle, QImg } from 'quasar';
import Message from '@/components/shared/mixins/Message.js';
import Formats from '@/components/shared/mixins/Formats.js';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QToggle,
    QImg,
    UploadImage
  },
  mixins: [Validation, Message, Formats, Resources],
  validations: {
    name: { required },
    visible: { required },
    orden: { required }
  },
  props: {
    dataVertical: Object,
    isNew: Boolean
  },
  data () {
    return {
      arrayVertical: this.dataVertical,
      idVertical: null,
      name: null,
      visible: false,
      imgImagen: null,
      orden: null,
      video: {
        file: null,
        name: ''
      },
      updateVideo: false,
      isUploading: false,
      updateLogotipo: false
    };
  },
  mounted () {
    this.$eventHub.$on(
      'APLICACION_ACTUALIZAR_INFORMACION',
      ({ callback, rejected }) => this.saveValues(callback, rejected)
    );

    this.$eventHub.$on('EJECUCION_GUARDAR_VIDEO', ({ callback, rejected }) =>
      this.saveVideo(callback, rejected)
    );

    this.$eventHub.$on('EJECUCION_GUARDAR_LOGOTIPO', ({ callback, rejected }) =>
      this.saveLogotipo(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('APLICACION_ACTUALIZAR_INFORMACION');
    this.$eventHub.$off('EJECUCION_GUARDAR_VIDEO');
    this.$eventHub.$off('EJECUCION_GUARDAR_LOGOTIPO');
  },
  methods: {
    refreshVideoInfo () {
      this.updateVideo = true;

      this.video.name = this.video.file.name;
    },
    async saveVideo (callback, rejected) {
      if (!this.updateVideo) return callback();
      this.isUploading = true;

      let uploadFile = await this.saveFile('Vertical', this.idVertical, 'Video', this.video.file);

      this.isUploading = false;

      if (!uploadFile.status) { return rejected(uploadFile); }

      this.updateVideo = false;

      return callback(uploadFile);
    },
    async saveLogotipo (callback, rejected) {
      if (!this.updateLogotipo) return callback();

      let uploadFile = await this.saveFile('Vertical', this.idVertical, 'Logotipo', this.imgImagen);
      if (!uploadFile.status) { return rejected(uploadFile); }

      this.updateLogotipo = false;

      return callback(uploadFile);
    },
    async saveValues (callback, rejected) {
      this.v$.$touch();
      if (this.v$.$error) {
        return rejected({
          data: null,
          status: false
        });
      }

      let dataArray = {
        name: this.name,
        visible: this.visible,
        displayOrder: parseInt(this.orden)
      };

      let result = false;

      if (this.isNew) {
        result = await this.saveNewApp(dataArray);
      } else {
        result = await this.saveUpdates(dataArray);
      }

      if (result.status) {
        callback(result);
      } else {
        rejected(result);
      }
    },
    async saveNewApp (dataArray) {
      let request = {
        controller: '/Vertical/',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.idVertical = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });
      return responseData;
    },
    async saveUpdates (dataArray) {
      let request = {
        controller: '/Vertical/' + this.idVertical,
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
          this.$router.push({ name: 'verticales' });
        });

      return responseData;
    },
    async refillData () {
      this.idVertical = this.arrayVertical.id;
      this.name = this.arrayVertical.name;
      this.visible = this.arrayVertical.visible;
      this.orden = this.arrayVertical.displayOrder;

      let resources = this.arrayVertical.resources;
      let logotipo = this.searchResource(resources, 'Logotipo');
      let video = this.searchResource(resources, 'Video');

      if (logotipo !== null) {
        this.imgImagen = await this.getImgFromBase64(logotipo.url);
      }
      if (video !== null) {
        this.video.file = await this.getImgFromBase64(video.url);
        // Set new name of a video API
        this.video.name = video.originalFileName;
      }
    }
  },
  watch: {
    dataVertical: {
      handler: function () {
        this.arrayVertical = this.dataVertical;
        if (Object.entries(this.dataVertical).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/style.scss";
// Component UploadFile
.upload-row {
  padding: 25px 0px 40px 0px;
  margin-left: auto;
  margin-right: auto;
  width: 200px;
  &:deep() {
    .inputStyle {
      margin: auto;
      color: white;
      font-size: 16px;
      font-weight: bold;
    }

    .q-field__control {
      background: $seafoam-blue !important;
    }
  }

  .upload-icon {
    font-size: 24px;
    margin-left: 4px;
    filter: invert(100%) sepia(100%) saturate(38%) hue-rotate(254deg)
      brightness(110%) contrast(110%);
  }
}
// End UploadFile
.container-app {
  .input-row {
    padding: 16px 0px;
  }
  /* Desplaza el contador de caracteres a la izquierda */
  &:deep() {
    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }
  }
}

.container-images {
  padding-left: 18px;
}

.container-order {
  padding: 16px 0px;
}

.info-box {
  display: flex;
  align-items: center;
}

.txt-info {
  font-family: "DINPro";
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: 1.5px;
  color: rgba(0, 0, 0, 0.87);
}
</style>
